import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import WireCard from './wire-performance-components/wire-card';
import MetricNumber from '../../common/metric-number';

const HFlex = styled.div`
  display: flex;
`;

const Container = styled(HFlex)`
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.secondaryColor};

  & > span {
    align-self: center;
    text-align: right;
    font-size: 29px;
    ${props => props.theme.isLarge && `
      width: 80px;
    `};
    ${props => props.theme.isXLarge && `
      width: 100px;
    `};
  }

  & > span:nth-child(3) {
    ${props => props.theme.isLarge && `
      width: 110px;
    `};
    ${props => props.theme.isXLarge && `
      width: 130px;
    `};
  }
`;

/* eslint-disable no-unused-vars */
export default function WirePerformance({
  id, slug, contributorName, contributorAvatarUrl, contributorSlug,
  title, publishedDate, views, engagements, likes, ctaClicks, enquiries, campaign,
}) {
  const cardProps = {
    id,
    slug,
    contributorName,
    contributorSlug,
    contributorAvatarUrl,
    title,
    publishedDate,
    campaign,
  };

  return (
    <Container>
      <WireCard {...cardProps} />
      <MetricNumber n={views} />
      <MetricNumber n={engagements} />
      <MetricNumber n={likes} />
      <MetricNumber n={ctaClicks} />
      <MetricNumber n={enquiries} />
    </Container>
  );
}
/* eslint-enable no-unused-vars */

WirePerformance.propTypes = {
  id: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  contributorName: PropTypes.string.isRequired,
  contributorAvatarUrl: PropTypes.string,
  contributorSlug: PropTypes.string.isRequired,
  publishedDate: PropTypes.string.isRequired,
  views: PropTypes.number.isRequired,
  engagements: PropTypes.number.isRequired,
  likes: PropTypes.number.isRequired,
  ctaClicks: PropTypes.number.isRequired,
  enquiries: PropTypes.number.isRequired,
  campaign: PropTypes.shape({
    name: PropTypes.string.isRequired,
    sentDate: PropTypes.string.isRequired,
  }),
};

WirePerformance.defaultProps = {
  contributorAvatarUrl: null,
  campaign: null,
};
